export function getLocalStorageItem(storageKey: string, name: string, def: any = undefined) {
    try {
        const params = JSON.parse(localStorage.getItem(storageKey) || '{}');
        return params[name] !== undefined ? params[name] : def;
    } catch (e) {
        return def;
    }
}
